/**
 * The CSS custom property a scroll container sets to place a DataGrid's sticky
 * horizontal scrollbar (`stickyHorizontalScrollbar`). Defaults to `0px`; a
 * scroller with bottom padding sets it to the negative of that padding so the
 * bar sits flush on its edge rather than floating over the rows.
 */
export const STICKY_SCROLL_BOTTOM_VAR = '--data-grid-sticky-scroll-bottom'
